import React from 'react';

const ConfirmDialogContext = React.createContext({});

export const ConfirmDialogProvider = ConfirmDialogContext.Provider;
export const ConfirmDialogConsumer = ConfirmDialogContext.Consumer;
export default ConfirmDialogContext;
